// Sticky mobile add-to-cart. Mirrors the main product form (selected variant price, sold-out state,
// button label) and proxies clicks to the real submit button, so the cart logic stays in one place.
class SwduStickyAtc extends HTMLElement {
  #observer;
  #mutation;
  #onClick = () => {
    const main = this.#mainButton();
    if (main && !main.disabled && main.type === 'submit') main.click();
  };

  connectedCallback() {
    this.button = this.querySelector('[data-sticky-atc-button]');
    this.label = this.querySelector('[data-sticky-atc-label]');
    this.price = this.querySelector('[data-sticky-atc-price]');
    this.form = document.querySelector('[data-quick-add-source] [data-product-form]');
    const sentinel = document.querySelector('[data-sticky-atc-sentinel]');
    if (!this.form || !sentinel || !this.button) return;

    this.button.addEventListener('click', this.#onClick);
    this.#mutation = new MutationObserver(() => this.#sync());
    this.#mutation.observe(this.form, { childList: true, subtree: true, attributes: true, characterData: true });
    const priceHost = document.querySelector('[data-quick-add-source] [data-product-price]')?.parentElement;
    if (priceHost) this.#mutation.observe(priceHost, { childList: true, subtree: true, characterData: true });

    // Show the bar once the main form has scrolled above the viewport.
    this.#observer = new IntersectionObserver(([entry]) => {
      const past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      this.toggleAttribute('data-visible', past);
      this.toggleAttribute('inert', !past);
    });
    this.#observer.observe(sentinel);
    this.#sync();
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
    this.#mutation?.disconnect();
    this.button?.removeEventListener('click', this.#onClick);
  }

  #mainButton() {
    return this.form?.querySelector('button[name="add"]') || this.form?.querySelector('form button[type="button"][disabled], form button[aria-disabled="true"]');
  }

  #sync() {
    const main = this.#mainButton();
    const available = Boolean(main && main.type === 'submit' && !main.disabled && main.getAttribute('aria-disabled') !== 'true');
    this.button.disabled = !available;
    this.button.setAttribute('aria-disabled', String(!available));
    if (main && this.label) this.label.textContent = main.textContent.trim();
    const sourcePrice = document.querySelector('[data-quick-add-source] [data-product-price]');
    if (sourcePrice && this.price) this.price.innerHTML = sourcePrice.innerHTML;
  }
}

if (!customElements.get('swdu-sticky-atc')) customElements.define('swdu-sticky-atc', SwduStickyAtc);
